import {createAction, handleActions} from "redux-actions";

const SET_SURVEY_DATA = 'survey/SET_SURVEY_DATA';
const CHANGE_STEP = 'survey/CHANGE_STEP';
const CHANGE_ANSWER = 'survey/CHANGE_ANSWER';
const CHANGE_ADDRESS = 'survey/CHANGE_ADDRESS';
const CHANGE_VISIBLE = 'survey/CHANGE_VISIBLE';

export const setSurveyData = createAction(SET_SURVEY_DATA, survey => survey);
export const changeStep = createAction(CHANGE_STEP, step => step );
export const changeAnswer = createAction(CHANGE_ANSWER, ({ column, answer }) => ({
    column,
    answer
}));

export const changeAddress = createAction(CHANGE_ADDRESS, ({ step, roadAddr, roadAddrDetail, baseAddr, zipNo}) => ({
    step,
    roadAddr,
    roadAddrDetail,
    baseAddr,
    zipNo
}));

export const changeVisible = createAction(CHANGE_VISIBLE, ({ step, hide }) => ({
    step,
    hide
}));

const initialState = {
    survey: null,
    answers: null
};

const survey = handleActions(
    {
        [SET_SURVEY_DATA]: (state, action) => ({
            ...state,
            survey: action.payload
        }),
        [CHANGE_STEP]: (state, action) => ({
            ...state,
            step: action.payload.step
        }),
        [CHANGE_ADDRESS]: (state, action) => ({
            roadAddr: action.payload.roadAddr,
            roadAddrDetail: action.payload.roadAddrDetail,
            baseAddr: action.payload.baseAddr,
            zpcd: action.payload.zipNo
        }),
        [CHANGE_VISIBLE]: (state, action) => {
            const newState = {
                ...state
            };
            newState.survey[action.payload.step].hide = action.payload.hide;
            return newState;
        }
    },
    initialState
);

export default survey;
